import { twMerge } from "tailwind-merge"
import { CSSProperties, forwardRef } from "react"
import { mergeRefs } from "../utils/mergeRefs"
import classNames from "classnames"
import { usePopover } from "./usePopover"
import { FloatingPortal } from "@floating-ui/react"
import type { PopoverContentProps } from "./types"

export const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(
  ({ children, className, style }, ref) => {
    const { floating, interactions, open } = usePopover()
    const { x, y } = floating || {}

    if (!open) return null

    const isContentHidden: boolean =
      floating?.middlewareData.hide?.escaped ||
      floating?.middlewareData.hide?.referenceHidden ||
      false

    const _styles: CSSProperties = {
      ...style,
      position: floating?.strategy,
      top: "0",
      left: "0",
      // Using translate instead of top/left to improve performance
      transform: `translate3d(${Math.round(Number(x))}px, ${Math.round(Number(y))}px, 0)`,
      visibility: isContentHidden ? "hidden" : "visible",
    }

    const _className = twMerge(classNames("rounded-lg bg-white shadow-md", className))

    return (
      <FloatingPortal>
        <div
          style={_styles}
          className={_className}
          ref={mergeRefs(floating?.refs.setFloating ?? null, ref)}
          {...interactions?.getFloatingProps()}
        >
          {children}
        </div>
      </FloatingPortal>
    )
  },
)

PopoverContent.displayName = "PopoverContent"
